import * as THREE from 'three'

export default class CrossroadsSection
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setStatic()
        this.setTiles()
    }

    setStatic()
    {
        const isProjectSign = (child) => {
            return (child.position && child.position.x > 7.5 && Math.abs(child.position.y) < 2.0)
        }

        const filteredBaseChildren = this.resources.items.crossroadsStaticBase.scene.children.filter(child => !isProjectSign(child))
        const filteredCollisionChildren = this.resources.items.crossroadsStaticCollision.scene.children.filter(child => !isProjectSign(child))

        this.objects.add({
            base: { children: filteredBaseChildren },
            collision: { children: filteredCollisionChildren },
            floorShadowTexture: this.resources.items.crossroadsStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }

    setTiles()
    {
        // To intro
        this.tiles.add({
            start: new THREE.Vector2(this.x, - 10),
            delta: new THREE.Vector2(0, this.y + 14)
        })

        // To projects (disabled)
        // this.tiles.add({
        //     start: new THREE.Vector2(this.x + 12.5, this.y),
        //     delta: new THREE.Vector2(7.5, 0)
        // })

        // To projects
        this.tiles.add({
            start: new THREE.Vector2(this.x - 13, this.y),
            delta: new THREE.Vector2(- 6, 0)
        })
    }
}
